import {
  Avatar,
  Card,
  Col,
  Collapse,
  Divider,
  Row,
  Table,
  Typography,
} from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import consentExpiry from "../../../../Assets/consentExpiry.png";
import consentMode from "../../../../Assets/consentMode.png";
import consentType from "../../../../Assets/consentTypes.png";
import consumerId from "../../../../Assets/consumerId.png";
import customerId from "../../../../Assets/customerIs.png";
import dataFliters from "../../../../Assets/dataFilters.png";
import fiDataLife from "../../../../Assets/fiDataLife.png";
import fidatapull from "../../../../Assets/fiDataPullFrequency.png";
import fiDataRange from "../../../../Assets/fiDataRange.png";
import fiType from "../../../../Assets/fiType.png";
import purpose from "../../../../Assets/purpose.png";
import { ReactComponent as Timer } from "../../../../Assets/timer.svg";
import { translation } from "../../../../i18n/translationConstant";
import { ConsentDetail } from "../../../../Models/Response/Consent/GetAllConsent";
import GetConsentByHandleResponse from "../../../../Models/Response/Consent/GetConsentByHandle";
import { GetConsentByIdResponse } from "../../../../Models/Response/Consent/GetConsentById";
import TimeFromNow from "../../../Common/Components/TimeFromNow";
import "./index.css";

interface IConsentDetailsProps extends React.PropsWithChildren {
  consentByUniqueIdDetails: GetConsentByIdResponse | GetConsentByHandleResponse;
  state?: any;
}

const columns = [
  {
    title: "type",
    dataIndex: "type",
  },
  {
    title: "operator",
    dataIndex: "operator",
  },
  {
    title: "value",
    dataIndex: "value",
  },
];
const ConsentDetails: React.FC<IConsentDetailsProps> = ({
  consentByUniqueIdDetails,
  children,
  state,
}) => {
  const [t] = useTranslation();
  const { Text } = Typography;

  const getCard = (consent: ConsentDetail) => {
    return (
      <Card
        key={consent.consentHandle}
        hoverable={false}
        bordered={false}
        className={`consentDetailsScreen`}
      >
        <Typography.Text className="consentCardFIU">1.</Typography.Text>
        <Avatar className="consentAvatar" src={consent.logoUrl} />

        <Typography.Text className="consentCardFIU width70 marginLeftFIU">
          {consent.fiuName}{" "}
          <Typography.Text className="font16ColorTercaryHintColor fontWeight400">
            {t(translation.lblWantsToAccessAccount)}
          </Typography.Text>
        </Typography.Text>
        {/* <Divider className="verticalDivider" type="vertical" />
        <Typography.Text className="font16ColorTercaryHintColor fontWeight500 width30">
          {t(translation.lblHandle)} :{" "}
          <Typography.Text className="font16ColorTercaryHintColor fontWeight600">
            {" "}
            {consent.consentHandle}
          </Typography.Text>
        </Typography.Text>
        <Divider className="verticalDivider" type="vertical" /> */}

        <Timer className="timer" />

        <TimeFromNow
          className="consentDetailsCardTime"
          date={consent.updatedOn}
        />
      </Card>
    );
  };

  return (
    <>
      <Card bordered={false} loading={false} className="consentDetailsCard">
        {getCard(state)}
        <div className="consentDetailsBody">
          <Row>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="detailsType"
            >
              <Text className="consentDetailsMessage">
                {t(translation.lblAccountPermissionAndInfoAccess)}
              </Text>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="detailsType"
            >
              <img
                alt=""
                src={fidatapull}
                height={40}
                width={40}
                className="iconBackground"
              />
              <div className="detailsDescription">
                <Text className="detailsTitle">
                  {t(translation.lblFiDataPullFrequency)} (
                  {consentByUniqueIdDetails.fetchType})
                </Text>
                <Text className="detailsValue">
                  {t(translation.lblInformatioFetch)}{" "}
                  {consentByUniqueIdDetails.Frequency.value}{" "}
                  {t(translation.lblTimes)}{" "}
                  {consentByUniqueIdDetails.Frequency.unit}
                  {"/s"}
                </Text>
              </div>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="detailsType"
            >
              <img
                alt=""
                src={consentType}
                height={40}
                width={40}
                className="iconBackground"
              />
              <div className="detailsDescription">
                <Text className="detailsTitle">
                  {t(translation.lblConsentType)}
                </Text>
                <Text className="detailsValue">
                  {consentByUniqueIdDetails.consentTypes.map((types, index) => {
                    let isComma;
                    index === consentByUniqueIdDetails.consentTypes.length - 1
                      ? (isComma = "")
                      : (isComma = ", ");

                    return types + isComma;
                  })}
                </Text>
              </div>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="detailsType"
            >
              <img
                alt=""
                src={purpose}
                height={40}
                width={40}
                className="iconBackground"
              />
              <div className="detailsDescription">
                <Text className="detailsTitle">{t(translation.PURPOSE)}</Text>
                <Text className="detailsValue">
                  {consentByUniqueIdDetails.Purpose.code} -
                  {consentByUniqueIdDetails.Purpose.text}
                </Text>
              </div>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="detailsType"
            >
              <img
                alt=""
                src={consentExpiry}
                height={40}
                width={40}
                className="iconBackground"
              />
              <div className="detailsDescription">
                <Text className="detailsTitle">
                  {t(translation.lblConsentExpiry)}
                </Text>
                <Text className="detailsValue">
                  {new Date(consentByUniqueIdDetails.consentExpiry)
                    .toDateString()
                    .slice(4)}
                </Text>
              </div>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="detailsType"
            >
              <img
                alt=""
                src={consentMode}
                height={40}
                width={40}
                className="iconBackground"
              />
              <div className="detailsDescription">
                <Text className="detailsTitle">
                  {t(translation.lblConsentMode)}
                </Text>
                <Text className="detailsValue">
                  {consentByUniqueIdDetails.consentMode}
                </Text>
              </div>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="detailsType"
            >
              <img
                alt=""
                src={consumerId}
                height={40}
                width={40}
                className="iconBackground"
              />
              <div className="detailsDescription">
                <Text className="detailsTitle">
                  {t(translation.lblConsumerId)}
                </Text>
                <Text className="detailsValue">
                  {consentByUniqueIdDetails.DataConsumer.id}
                </Text>
              </div>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="detailsType"
            >
              <img
                alt=""
                src={dataFliters}
                height={40}
                width={40}
                className="iconBackground"
              />
              <Collapse>
                <Collapse.Panel key={1} header={t(translation.lblDataFilters)}>
                  <Table
                    columns={columns}
                    dataSource={consentByUniqueIdDetails.DataFilter}
                    pagination={false}
                  />
                </Collapse.Panel>
              </Collapse>
            </Col>
            {/* <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="detailsType"
            >
              <img
                alt=""
                src={customerId}
                height={40}
                width={40}
                className="iconBackground"
              />
              <div className="detailsDescription">
                <Text className="detailsTitle">{"Consumer ID"}</Text>
                <Text className="detailsValue">
                  {consentByUniqueIdDetails.Customer.id}
                </Text>
              </div>
            </Col> */}
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="detailsType"
            >
              <img
                alt=""
                src={customerId}
                height={40}
                width={40}
                className="iconBackground"
              />
              <div className="detailsDescription">
                <Text className="detailsTitle">{t(translation.lblConsentStart)}</Text>
                <Text className="detailsValue">
                  {new Date(consentByUniqueIdDetails.consentStart)
                    .toDateString()
                    .slice(4)}
                </Text>
              </div>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="detailsType"
            >
              <img
                alt=""
                src={fiDataRange}
                height={40}
                width={40}
                className="iconBackground"
              />
              <div className="detailsDescription">
                <Text className="detailsTitle">
                  {t(translation.lblFiDataRange)}
                </Text>
                <Text className="detailsValue">
                  {t(translation.From)}{" "}
                  {new Date(consentByUniqueIdDetails.FIDataRange.from)
                    .toDateString()
                    .slice(4)}{" "}
                  {t(translation.to)}{" "}
                  {new Date(consentByUniqueIdDetails.FIDataRange.to)
                    .toDateString()
                    .slice(4)}
                </Text>
              </div>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="detailsType"
            >
              <img
                alt=""
                src={fiType}
                height={40}
                width={40}
                className="iconBackground"
              />
              <div className="detailsDescription">
                <Text className="detailsTitle">{t(translation.FIType)}</Text>
                <Text className="detailsValue">
                  {consentByUniqueIdDetails.fiTypes.map((types, index) => {
                    let isComma;
                    index === consentByUniqueIdDetails.fiTypes.length - 1
                      ? (isComma = "")
                      : (isComma = ", ");

                    return types + isComma;
                  })}
                </Text>
              </div>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="detailsType"
            >
              <img
                alt=""
                src={fiDataLife}
                height={40}
                width={40}
                className="iconBackground"
              />
              <div className="detailsDescription">
                <Text className="detailsTitle">
                  {t(translation.lblFiDataLife)}
                </Text>
                <Text className="detailsValue">
                  <Text className="detailsValue">
                    {consentByUniqueIdDetails.DataLife.value}{" "}
                    {consentByUniqueIdDetails.DataLife.unit}
                  </Text>
                </Text>
              </div>
            </Col>
          </Row>
          {children}
        </div>
      </Card>
    </>
  );
};

export default ConsentDetails;
